
























































































import { defineComponent, toRefs, PropType, computed } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData, CreateMode } from '@tt4b/ttam-enums';
import AdCompliance from './index';
import ALink from '@/components/common/a-link/a-link.vue';
import { useCreativeActionTypeIs } from '@tt4b/ttam-hooks';

const name = 'ttam-ad-compliance-compose';
export default defineComponent({
  name,
  components: {
    ALink,
    TtamAdComplianceInfo: AdCompliance.TtamAdComplianceInfo,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    showLeadAdsProtocal: {
      type: Boolean,
      default: false,
    },
    showBulkAdsProtocal: {
      type: Boolean,
      default: false,
    },
    createMode: {
      type: String,
      default: CreateMode.CREATE,
    },
    smallSize: {
      type: Boolean,
      default: false,
    },
    is1nn: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { adgroupData, createMode, showLeadAdsProtocal, showBulkAdsProtocal } = toRefs(props);

    const { isEdit } = useCreativeActionTypeIs({
      createMode,
      adgroupFormData: adgroupData,
    });

    const isVisible = computed(() => showBulkAdsProtocal.value || showLeadAdsProtocal.value || !isEdit.value);

    return {
      name,
      isEdit,
      isVisible,
    };
  },
});
